import { useState } from 'react';
import { ChatIcon, ChatWithNotificationIcon } from '../../../../assets/icons';
import { SecondaryButton } from '../../../../core/components';
import { useHubSpotUnreadListener } from '../../../../core/hooks/use-hubspot-unread-listener';
import { openHubSpotWidgetChat, showHubSpotWidget } from '../../../../core/utils';

export const ChatButton = () => {
  const [hasUnreadConversation, setHasUnreadConversation] = useState(false);
  const callbackHandler = (hasUnread: boolean) => setHasUnreadConversation(hasUnread);

  useHubSpotUnreadListener({ callback: callbackHandler });
  return (
    <SecondaryButton
      onClick={() => {
        showHubSpotWidget();
        openHubSpotWidgetChat();
      }}
      icon={hasUnreadConversation ? <ChatWithNotificationIcon /> : <ChatIcon />}
    >
      Support
    </SecondaryButton>
  );
};
